import { useForm } from "react-hook-form";
import AppInput from "@/components/form/input-field";
import PrimaryBtn from "@/components/button/primaryBtn";
import { yupResolver } from "@hookform/resolvers/yup";
import { signInWithOtpSchema } from "@/utils/validation/schema/auth";
import { useRouter } from "next/router";

import successToast from "@/utils/toast";
import en from "@/localization/en.json";
import getGRecaptchaToken from "@/services/googleReCaptcha";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useLoginByPhone } from "@/api/client/auth";
import { createJwtToken } from "@/services/jsonwebtoken";

function SigInWithOtp({ onSubmit }) {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const router = useRouter();

  const { isLoading: isLoginLoading, mutate: loginByPhone } = useLoginByPhone({
    onSuccess: (successData) => {
      successToast(successData.message);
      onSubmit({
        phone: successData.data.phone,
        signature: successData.data.signature,
      });
    },
    onError: (errorData) => {
      errorData.errors.forEach(({ name, message }) => {
        setError(name, { message });
      });
    },
  });

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onBlur",
    resolver: yupResolver(signInWithOtpSchema),
  });

  const requestToSendOtp = async (data) => {
    const countryCode = "+88";
    let userData = {
      phone: data.phone.startsWith(countryCode)
        ? data.phone.split(countryCode)[1]
        : data.phone,

      gRecaptchaToken: await getGRecaptchaToken(executeRecaptcha, "sendOtp"),
      token: createJwtToken(),
    };
    loginByPhone(userData);
  };

  return (
    <>
      <form className="sm:w-[480px]" onSubmit={handleSubmit(requestToSendOtp)}>
        <h1 className="text-[1.75rem] text-[#0A101A] tracking-[0.14px] font-semibold mb-[1.875rem]">
          {en["common.sign_in"]}
        </h1>

        <AppInput
          labelName={en["common.phone_number"]}
          type="number"
          placeholder={en["common.enter_phone_number"]}
          name="phone"
          isFieldRequired
          register={register}
          error={errors.phone}
        />
        <PrimaryBtn
          btnText="Sign In"
          className="w-full h-[3.5rem] mt-[1.875rem]"
          isLoading={isLoginLoading}
        />
      </form>

      <p className="text-center mt-[2.5rem] text-[#414E5F] text-[1.063rem]">
        Already Registered with email?
        <span
          className="text-[#E91F63] underline cursor-pointer ml-1"
          onClick={() =>
            router.push({
              pathname: "/signin/email",
              query: { ...router.query },
            })
          }
        >
          Sign in with email
        </span>
      </p>
    </>
  );
}

export default SigInWithOtp;
